export default {
  amber: "엠버",
  hutao: "호두"
};
